<template lang="pug">
div
  forms-confirmation-dialog-selector-vue(
    v-for="modal in modals"
    :data="modal.values"
    :ref="modalKey(modal.tipoid[0].toString(), modal.name)"
    @confirm="confirm(modal.tipoid[0].toString(), modal.name, $event)"
    component="forms-autocomplete-tree-selector-vue"
    :title="modal.label"
  )
</template>

<script>
export default {
  name: 'sofia-filter-modals-vue',
  props: {
    sofiaFilters: { type: Array, default: () => [] }
  },
  components: {
    'forms-confirmation-dialog-selector-vue': () => import(
      /* webpackChunkName: "[request]" */ "components/forms/ConfirmationDialogSelector"
    )
  },
  computed: {
    modals() {
      return this.sofiaFilters.filter(filter => filter.type == 'modal')
    }
  },
  methods: {
    confirm(tipoid, name, selectedValues) {
      this.$emit('confirm_filter_values', tipoid, name, selectedValues)
    },
    showModal(tipoid, name) {
      var modalRef = this.$refs[this.modalKey(tipoid, name)]
      var modal = Array.isArray(modalRef) ? modalRef[0] : modalRef

      modal.showModal()
    },
    clearModal(tipoid, name) {
      var modalRef = this.$refs[this.modalKey(tipoid, name)]
      var modal = Array.isArray(modalRef) ? modalRef[0] : modalRef

      modal.clear()
    },
    modalKey(tipoid, name) {
      return `sofia-filter-modals-${name}_${tipoid}`
    }
  }
}
</script>
